import React, { Component, Fragment } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Warning from '@material-ui/icons/Warning';

const styles = ({
    internetError: {
        backgroundColor: "#FFA000",
        height: 40,
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center'
    },
    message: {
        margin: 0,
        display: 'flex',
        fontSize: 19,
        color: '#FFF',
        padding: 5
    },
    warningIcon: {
        marginRight: 8,
        marginTop: 1
    }
});

export default function (ComposedComponent) {
    class NetworkDetector extends Component {
        state = {
            isDisconnected: false
        }

        componentDidMount() {
            this.handleConnectionChange();
            window.addEventListener('online', this.handleConnectionChange);
            window.addEventListener('offline', this.handleConnectionChange);
        }

        componentWillUnmount() {
            window.removeEventListener('online', this.handleConnectionChange);
            window.removeEventListener('offline', this.handleConnectionChange);
        }


        handleConnectionChange = () => {
            const condition = navigator.onLine ? 'online' : 'offline';
            if (condition === 'online') {
                const webPing = setInterval(
                    () => {
                        fetch('//google.com', {
                            mode: 'no-cors',
                        })
                            .then(() => {
                                this.setState({ isDisconnected: false }, () => {
                                    return clearInterval(webPing)
                                });
                            }).catch(() => this.setState({ isDisconnected: true }))
                    }, 2000);
                return;
            }

            return this.setState({ isDisconnected: true });
        }

        render() {
            const { isDisconnected } = this.state,
                { classes } = this.props;
            return (
                <Fragment>
                    {isDisconnected && (
                        <div className={classes.internetError}>
                            <span className={classes.message}>
                                <Warning className={classes.warningIcon} />
                                Internet connection lost!
                            </span>
                        </div>
                    )}
                    <ComposedComponent {...this.props} />
                </Fragment>
            );
        }
    }

    return withStyles(styles, { withTheme: false })(NetworkDetector);
}



// WEBPACK FOOTER //
// ./src/hoc/NetworkDetection.js